// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_3c78bdc","attribute":"_aa1a85e","running":"_30ce9a4","lateReg":"_5b97762","startTime":"_51cd79d","tooltip":"_1dfff77"};